/** @typedef {{className:String|null,apiCall:DR.ApiCall}} T.TrustedBy.Par */
/**
 * @class
 * @param {T.TrustedBy.Par} par
 * @extends mkE.Base
 */
T.TrustedBy = Class(
	/**
	 * @lends {T.TrustedBy#}
	 */
	{
		/** @type {T.TrustedBy.Par} */
		par: {},

		/** @param {T.TrustedBy.Par} par */
		__construct(par = {}) {
			par.className = par.className || '';
			this.par = par;
			this.node = mkE({
				tag: 'div',
				id: 'T_TrustedBy',
				className: par.className,
				els: [
					{
						tag: 'div',
						className: 'container mb-3',
						els: [
							{
								tag: 'div',
								className: 'h2',
								text: t('b2b.trusted_by.title')
							}
						]
					},
					this._slideNode = mkE({
						tag: 'div',
						className: 'slide'
					})
				]
			});

			this._mGetTrustedBy = new DR.web.GetTrustedBy();
			this._mGetTrustedBy.onLoad = this._mGetTrustedByRe;
			this._mGetTrustedBy.select = [
				new DR.roadgames.select.Image().small().medium().large().original()
			];
			par.apiCall.addMethod(this._mGetTrustedBy);
		},

		_mGetTrustedByRe() {
			const re = this._mGetTrustedBy.re;
			if (re.image) {
				const image = new Image;
				image.onload = this._onLoadImage;
				image.src = re.image.small;
			} else {
				this.remove();
			}
		},

		_onLoadImage(e) {
			const image = e.target;
			const re = this._mGetTrustedBy.re;
			this._slideNode.style.width = image.width + 'px';
			this._slideNode.style.height = image.height + 'px';
			const pixelsPerSecond = 140;
			this._slideNode.style.animationDuration = Math.ceil(image.width / pixelsPerSecond) + 's';
			const node = mkE({
				tag: 'div',
				style: {
					width: Math.max(image.width * 2, screen.width * 2) + 'px',
					backgroundImage: `url(${re.image.small})`,
				}
			}).append(this._slideNode);
			if (CSS.supports('background', 'image-set(url())')) {
				node.style.backgroundImage = `image-set(url("${re.image.small}") 1x, url("${re.image.medium}") 2x, url("${re.image.large}") 3x`;
			}
		}
	},
	mkE.Base
);